module.exports = __webpack_public_path__ + "img/69.c9af5ae8.jpg";